import React from "react";
import TagsModal from "../TagsModal";
import { MenuItems } from "../../@types";
import { useSetManyTags } from "../hooks";
import { checkForEmptySave, noTagChangeNotification } from "../utils";

type TagsEditManyProps = {
  hashes: string[];
  show: boolean;
  handleShow: () => boolean;
  selectedCountTotalOverLimit?: boolean;
  mixedSamplesInSelection?: boolean;
};

const TagsEditMany = ({
  hashes,
  show,
  handleShow,
  selectedCountTotalOverLimit = false,
  mixedSamplesInSelection = false
}: TagsEditManyProps) => {
  const { mutate: setManyTags } = useSetManyTags();

  const onFormSubmit = (selectedTags: MenuItems) => {
    if (checkForEmptySave(selectedTags)) {
      noTagChangeNotification();
    } else {
      setManyTags({ selectedTags, hashes });
    }
  };

  const noLocalSamplesFoundInSelection = hashes?.length === 0 ?? true;

  return (
    <TagsModal
      show={show}
      handleShow={handleShow}
      onFormSubmit={onFormSubmit}
      selectedCountTotalOverLimit={selectedCountTotalOverLimit}
      mixedSamplesInSelection={mixedSamplesInSelection}
      noLocalSamplesFoundInSelection={noLocalSamplesFoundInSelection}
    />
  );
};

export default TagsEditMany;
